import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";

import Swal from "sweetalert2";
import { Router } from '@angular/router';
import * as moment from 'moment';
import { UserMgmtService } from "../../user-management/user-management.service";
import { ExcelService } from "../../dashboard/excel.service";
@Component({
  selector: 'app-auditlog',
  templateUrl: './auditlog.component.html',
  styleUrls: ['./auditlog.component.scss']
})
export class AuditlogComponent implements OnInit {
  @ViewChild(DatatableComponent,{ static: false }) table: DatatableComponent;
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;
  userId: number;
  statusForm: FormGroup;
  resetPasswordForm: FormGroup;
  subscriptiondata: any;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "In-Active" },
    { id: "suspended", name: "Suspended" },
    { id: "blocked", name: "Blocked" }
  ];
  userlist = [];
  temp = [];
  // userlist = [{ firstname: "Manish", lastName: "Singh", email: "inder@gmail.com ", status: "Active", creationDate: "1565695077" },
  // { firstname: "khurana", lastName: "khurana", email: "khurana@gmail.com ", status: "Blocked", creationDate: "1565695077" }];

  columns = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 50 ;
  offset: number = 0 ;
  rowCount:number = 0 ;
  userSearchType: string = "";
  startDateEpoch: any;
  endDateEpoch: any;
  startDateObj = { year: null, month: null, day: null };
  endDateObj = { year: null, month: null, day: null };
  startDate: any;
  endDate: any;
  usercount: any;
  downloadList: Array<object> = [];
  paymentHistList:Array<object> = [];
  DateRangeQuery: string = "";
  // paymentHistList=[{
  //   lastPaymentDate:1584448638,
  //   lastSubscriptionAmount:20,
  //   brand:'visa',
  //   last4:'3832'
  // }];
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"sm"
  };

  inviteCode:string = '';
  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ExcelService: ExcelService
  ) { }
  ngOnInit() {
    this.getUserList();
    this.getdownloadList();
  }
  reset() {
    this.offset = 0;
    this.startDate = null;
    this.endDate = null;
    this.textSearch = '';
    this.getUserList();
  
  }

  getUserList() {
    this.spinner.show();
    let query ="panel=yes&offset=0&limit="+this.pageLimit;
    if(this.userSearchType){
      query= query+"typeOfAction="+this.userSearchType
    }
    this.userMgmtService.getAuditlogs(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.userlist =  res.data.auditLogs;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }
    });
  }
  onChangePageLimit(){
    this.getUserList()

  }
  textSearch:string = ''
  applySearch() {

    let startEpoc = new Date(this.startDate).getTime();
    startEpoc = startEpoc / 1000;
    startEpoc = startEpoc
    let endEpoc = new Date(this.endDate).getTime();
    endEpoc = endEpoc / 1000;

    let query;

    this.spinner.show();

    if (this.startDate == undefined) {
      query = "";
    }
    if (this.endDate == undefined) {
      query = "";
    }
    if(this.startDate && this.endDate) {
      query  = query+ "&startDate=" + startEpoc + "&endDate=" + endEpoc;
    }
    if (this.textSearch !== '' && this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
    if(this.userSearchType){
      query= query+"typeOfAction="+this.userSearchType
    }
     query= query+"&limit="+this.pageLimit+"&offset="+this.offset;
    this.userMgmtService.getAuditlogs(query).subscribe(res => {

      if ((res["message"] == "Success")) {
        this.userlist =  res.data.auditLogs;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;
        this.spinner.hide();
      } else {

        this.userlist = [];
      }

    });
    this.spinner.hide();
  }
  setPage(pageInfo) {
      this.offset = this.pageLimit * pageInfo.offset;
      this.applySearch();
    
  }
  display (seconds) {
    const format = val => `0${Math.floor(val)}`.slice(-2)
    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
  
    return [hours, minutes, seconds % 60].map(format).join(':')
  }
  userSearchTypeChanged() {

    let query = "";
    if(this.userSearchType){
      query= query+"typeOfAction="+this.userSearchType
    }

    this.spinner.show();
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.userlist = res.data.userList;
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;

        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    });
  }


  onStartTimeChange(value: { year: string; month: string; day: string }) {
    let startDateString = value.year + "-" + value.month + "-" + value.day;
    this.startDateEpoch = new Date(startDateString).getTime();
  }

  onEndTimeChange(value: { year: string; month: string; day: string }) {
    let endDateString = value.year + "-" + value.month + "-" + value.day;
    this.endDateEpoch = new Date(endDateString).getTime();
    this.endDateEpoch + 84600000;
  }


  updateUserStatusModal1(row, content, btn) {

    this.userId = row.userId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  paymentHistoryModal(row, content, btn) {

    this.userId = row.userId;
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    this.modalRef = this.modalService.open(content,modelOptions1);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  vitalDetail:any;
  vitalPercentageModal(row, content, btn) {
    this.userId = row.userId;
    this.spinner.show();
    let query = 'userId=' + this.userId;
    this.userMgmtService.getVital(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.vitalDetail = res.data;
        this.spinner.hide();
        this.modalRef = this.modalService.open(content,modelOptions1)
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    }, err => {
      this.spinner.hide();
    });
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    // this.modalRef = this.modalService.open(content,modelOptions1);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  getPaymentHistory(userId:any) {
    this.userMgmtService.historyPayment(userId).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.paymentHistList = res.data.paymentList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.paymentHistList = [];
      }
    });
  }
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.ExcelService.exportAsExcelFile(this.downloadList,"Admin_User_Details_"+ month + "/" + day + "/" + year);
  }
  getdownloadList(){
    let query ='panel=yes&isDownload=true'
    this.userMgmtService.getAuditlogs(query).subscribe(res => {
      if ((res["message"] == "Success")) {
     let tempList=res.data.auditLogs;
      tempList.forEach(element => {
        let Obj={
          Name:element['fullName'] || 'NA',
          User_Role:element['userRole'] || 'NA',
          type_Of_Action:element['typeOfAction'] || 'NA',
          Date: moment.unix(element['insertDate']).format("MM/DD/YYYY HH:mm:ss"),
          email:element['email'] || 'NA', 
          admin_IP:element['adminIp']
        }
      this.downloadList.push(Obj)
      });
      } else {
      }
    });

  }
 
  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.email.toLowerCase().indexOf(val) !== -1 || !val;
    });
    const email = this.temp.filter(function(d) {
      return d.userName.toLowerCase().indexOf(val) !== -1 || !val;

    });

    this.userlist = temp.concat(email);
    this.rowCount= this.userlist.length;
    // update the rows
    // this.userlist = temp;
    this.table.offset = 0;
  
  }



  deleteRecord(record: any) {

    this.spinner.show();

    this.userMgmtService.deleteUser(this.userId).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "User Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getUserList();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }

  searchTextChanged(event: any) {
    if (event == "") {
      this.getUserList();
    }
  }

  // USER UPDATE STATUS BLOCK
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }


  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };

      this.userMgmtService.updateUserStatus(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef.close();
          this.getUserList();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



}

